import React, { forwardRef } from "react";
import "../../../../../assets/styles/judgeSheet.scss";

export const SHEET_WIDTH = 1836;
export const SHEET_HEIGHT = 2376;

export interface JudgingSheetTemplateProps {
  imageSrc: string;
  entryClassLabel: string;
  dateStr: string;
  entryNumber: number | string | undefined;
  judgeName: string;
  judgeNumber: number; // Judge Panel の #1・#2・#3
  groupName: string;
  songLabel: string; // "Song 1" / "Song 2"
}

// グループ名が長いときに崩れないよう、文字数に応じてフォントサイズを落とす
const getGroupNameFontSize = (name: string) => {
  if (name.length > 24) return 26;
  if (name.length > 16) return 32;
  return 42;
};

const getTopBarFontSize = (name: string) => {
  if (name.length > 30) return 22;
  if (name.length > 20) return 26;
  return 30;
};

const JudgingSheetTemplate = forwardRef<
  HTMLDivElement,
  JudgingSheetTemplateProps
>(
  (
    {
      imageSrc,
      entryClassLabel,
      dateStr,
      entryNumber,
      judgeName,
      judgeNumber,
      groupName,
      songLabel,
    },
    ref,
  ) => {
    const topBarFontSize = getTopBarFontSize(groupName);
    const groupNameFontSize = getGroupNameFontSize(groupName);

    return (
      <div
        ref={ref}
        className="judging-sheet-page"
        style={
          {
            "--sheet-width": `${SHEET_WIDTH}px`,
            "--sheet-height": `${SHEET_HEIGHT}px`,
          } as React.CSSProperties
        }
      >
        <img
          src={imageSrc}
          alt=""
          width={SHEET_WIDTH}
          height={SHEET_HEIGHT}
          className="judging-sheet-page-image"
        />
        <div className="judging-sheet-page-topbar-title">
          {entryClassLabel}　|　{dateStr}
        </div>
        <div
          className="judging-sheet-page-topbar-left"
          style={{ fontSize: topBarFontSize }}
        >
          No.{entryNumber ?? "-"} {groupName}
        </div>

        <div className="judging-sheet-page-topbar-right">
          {judgeName} #{judgeNumber}
        </div>

        <div className="judging-sheet-page-divider" />
        <div className="judging-sheet-page-groupname">{songLabel}</div>
        <div className="judging-sheet-page-Score-area">
          {songLabel}
          <br />
          Score
        </div>
      </div>
    );
  },
);

JudgingSheetTemplate.displayName = "JudgingSheetTemplate";

export default JudgingSheetTemplate;
